import React from 'react';
import { SearchResult } from './useGlobalSearch';

interface SearchResultItemProps {
  result: SearchResult;
  isSelected: boolean;
  onClick: () => void;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({ 
  result, 
  isSelected, 
  onClick 
}) => {
  return (
    <li
      className={`px-4 py-3 cursor-pointer text-sm hover:bg-gray-100 transition-colors duration-150 ${
        isSelected ? 'bg-gray-100' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        {/* Result content */}
        <div className="flex-1 min-w-0">
          <div className="font-medium text-gray-900 truncate">
            {result.displayName || result.name}
          </div>
          {result.subtitle && (
            <div className="text-xs text-gray-500 truncate">
              {result.subtitle}
            </div>
          )}
        </div>
        
        {/* Type indicator */}
        <div className="flex-shrink-0">
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            {result.type === 'artist' ? 'Artist' : 'Aligned Contributor'}
          </span>
        </div>
      </div>
    </li>
  );
};

export default SearchResultItem;